export default __webpack_public_path__ + "static/media/up-coming-event-2.e050a63b.png";